import { useReveal } from "@/hooks/useReveal";

// Consistent section wrapper — controls id (anchor), padding, background & max width.
export function Section({ id, className = "", bg = "white", children }) {
  const bgMap = {
    white: "bg-white",
    mist: "bg-mist",
    navy: "bg-navy text-white",
    navyDark: "bg-navy-dark text-white",
  };
  return (
    <section
      id={id}
      className={`${bgMap[bg]} py-20 md:py-28 lg:py-32 scroll-mt-20 ${className}`}
    >
      <div className="mx-auto w-full max-w-7xl px-6 md:px-8">{children}</div>
    </section>
  );
}

// Eyebrow + title + optional subtitle, with reveal animation.
export function SectionHeading({ eyebrow, title, subtitle, align = "left", light = false }) {
  const ref = useReveal();
  const alignCls = align === "center" ? "text-center mx-auto items-center" : "text-left items-start";
  return (
    <div ref={ref} className={`reveal flex flex-col ${alignCls} max-w-2xl ${align === "center" ? "" : ""}`}>
      {eyebrow && (
        <span
          className={`text-xs md:text-sm font-semibold uppercase tracking-[0.2em] ${light ? "text-gold-light" : "text-gold-dark"}`}
          data-testid="section-eyebrow"
        >
          {eyebrow}
        </span>
      )}
      <div className={`gold-rule my-4 ${align === "center" ? "mx-auto" : ""}`} />
      <h2 className={`font-heading text-3xl md:text-4xl lg:text-5xl font-semibold leading-tight ${light ? "text-white" : "text-navy"}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-4 text-base md:text-lg leading-relaxed ${light ? "text-white/70" : "text-charcoal/70"}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}
